import { useEffect, useState } from "react";

export const usePrevIfUndefined = <Value>(value: Value): Value => {
  const [memoized, updateMemoized] = useState(value);

  useEffect(() => {
    if (value !== undefined) {
      updateMemoized(value);
    }
  }, [value]);

  return memoized;
};
